export class GiftShopAPI {
  static readonly GET_ALL_ITEMS: string = 'api/GiftShopLoyalty';
  static readonly GET_ITEM_DETAILS: string = 'api/GiftShopLoyalty/Get Details';
  static readonly ADD_ORDER: string = 'api/GiftShopLoyalty/Add Order';
}

export class CateringAPI {
  static readonly GET_ALL_SPECIAL_OFFERS: string =
    'api/SpecialOffers/Get All Active And Show Offers For Catering';
}

export class BettingAPI {
  static readonly GET_ALL_SPECIAL_OFFERS: string =
    'api/SpecialOffers/Get All Active And Show Offers For Betting';
}

export class AuthenticationAPI {
  static readonly LOGIN: string = 'api/Authentification/Login';
  static readonly REFRESH_TOKEN: string = 'api/Authentification/Refresh';
  static readonly REGISTER: string = 'api/Authentification/Register';
  static readonly SAVE_USER_INFO: string =
    'api/Authentification/Save User Info';
  static readonly RECOVER: string = 'api/Authentification/Recovery';
  static readonly HIDE_EXPIRING_MBC_NOTIFIACTION: string =
    'api/Authentification/Hide Expiring MBC Notification';
}

export class PurchaseAPI {
  static readonly CATERING_PURCHASE: string = 'api/Purchase/Catering Purchase';
  static readonly BETTING_PURCHASE: string = 'api/TicketScan/Scan Ticket';
}

export class DescriptionsAPI {
  static readonly GET_GAME_RULES: string = 'api/Authentification/GetGameRules';
}

export class PromotionsAPI {
  static readonly GET_ALL_PROMOTIONS: string =
    'api/Promotions/Get All Active And Show Promotions';
}

export class TransactionsAPI {
  static readonly GET_ALL_TRANSACTIONS_FOR_CATERING: string =
    'api/TransactionHistory/Get All Catering Transactions For User';
  static readonly GET_ALL_TRANSACTIONS_FOR_BETTING: string =
    'api/TransactionHistory/Get All Betting Tickets For User';
  static readonly GET_ALL_TRANSACTIONS_FOR_FREE_TO_PLAY: string =
    'api/TransactionHistory/Get All Free To Play Tickets For User';
  static readonly GET_TRANSACTIONS_FOR_ALL_EXPIRING_MBC: string =
    'api/TransactionHistory/Get All Expired Mbc For User';
}

export class VouchersAPI {
  static readonly GET_ALL_VOUCHERS: string = 'api/VouchersLoyalty/Get Vouchers';
  static readonly GET_ALL_PURCHASED_VOUCHERS: string =
    'api/VouchersLoyalty/Get Purchased Vouchers For User ';
  static readonly GET_MBC_VOUCHER_DETAILS: string =
    'api/VouchersLoyalty/Get Voucher Details ';
  static readonly GET_PRODUCT_VOUCHER_DETAILS: string =
    'api/VouchersLoyalty/Get Product Voucher Details ';
  static readonly GET_PURCHASED_VOUCHER_DETAILS: string =
    'api/VouchersLoyalty/Get Purchased Voucher Details ';
  static readonly ACTIVATE_MBC_VOUCHER: string =
    'api/VouchersLoyalty/Activate Purchased Voucher ';
  static readonly ACTIVATE_PRODUCT_VOUCHER: string =
    'api/VouchersLoyalty/Activate Purchased Product Voucher ';
  static readonly BUY_MBC_VOUCHER: string =
    'api/VouchersLoyalty/Add Purchased Voucher';
  static readonly BUY_PRODUCT_VOUCHER: string =
    'api/VouchersLoyalty/Add Purchased Product Voucher';
}

export class FreeToPlayAPI {
  static readonly GET_ALL_PUBLISHED_TICKETS: string =
    'api/FreeToPlayLoyalty/Get Published Tickets ';
  static readonly GET_ALL_SUBMITTED_TICKETS: string =
    'api/FreeToPlayLoyalty/Get Verified Tickets ';
  static readonly GET_PUBLISHED_TICKET_DETAILS: string =
    'api/FreeToPlayLoyalty/Get Published Ticket Details ';
  static readonly GET_VERIFIED_TICKET_DETAILS: string =
    'api/FreeToPlayLoyalty/Get Verified Ticket Details ';
  static readonly SUBMITT_TICKET: string =
    'api/FreeToPlayLoyalty/Submit Ticket';
}

export class BettingTasksAPI {
  static readonly GET_ALL_BETTING_TASKS: string =
    'api/BettingTasksLoyalty/Get All Tasks ';
}
